import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  { n: "01", title: "Request an Appointment", text: "Submit your details through the consultation form." },
  {
    n: "02",
    title: "Speak With Our Team",
    text: "Our USA consultation team contacts you to understand your requirements and appointment availability.",
  },
  { n: "03", title: "Attend Your Consultation", text: "Meet Dr. Santhisree during her USA visit." },
  {
    n: "04",
    title: "Receive Personalized Guidance",
    text: "Depending on your selected consultation, receive your assessment, recommendations, parent guidance and applicable take-home materials.",
  },
];

export default function HowItWorks({ onRequest }) {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="bg-[#FAF7F2] py-16 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-2xl">
          <Eyebrow>Chapter 07 · The Process</Eyebrow>
          <h2 className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1B3B2B] tracking-tight">
            How the Consultation Works
          </h2>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6 relative">
          <div className="hidden lg:block absolute top-10 left-[12%] right-[12%] h-px bg-[#E5D3AD]" />
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.12}>
              <div data-testid={`step-${s.n}`} className="relative h-full bg-[#F4EFE6] rounded-3xl p-7 border border-[#E5D3AD]/40 hover:border-[#C5A059] hover:-translate-y-1.5 transition-all duration-500">
                <p className="font-serif text-5xl text-[#C5A059]">{s.n}</p>
                <p className="mt-4 font-serif text-xl text-[#1B3B2B]">{s.title}</p>
                <p className="mt-2.5 text-sm text-[#5C6E62] leading-relaxed">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15} className="mt-12 text-center">
          <button
            data-testid="how-it-works-cta"
            onClick={() => onRequest()}
            className="bg-[#1B3B2B] text-[#FAF7F2] font-semibold tracking-wide text-sm px-8 py-4 rounded-full hover:bg-[#132C20] transition-all duration-300 hover:-translate-y-0.5 shadow-[0_12px_32px_rgb(27,59,43,0.2)]"
          >
            REQUEST AN APPOINTMENT
          </button>
        </Reveal>
      </div>
    </section>
  );
}
